export const INDICATOR_LOAD_ATTEMPT = "INDICATOR_LOAD_ATTEMPT";
export const INDICATOR_LOAD_SUCCESS = "INDICATOR_LOAD_SUCCESS";
export const INDICATOR_LOAD_FAILED = "INDICATOR_LOAD_FAILED";
